module.exports = __webpack_public_path__ + "static/media/PND91.8860ce7d.pdf";